import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const LoginSuccess = () => {
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);
  const extensionUrl = searchParams.get('extension_url');

  useEffect(() => {
    if (!extensionUrl) {
      // If no extension URL, redirect to dashboard immediately
      window.location.href = '/';
      return;
    }

    // Decode the extension URL if it's URL-encoded
    const decodedUrl = decodeURIComponent(extensionUrl);

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Close the tab after countdown
          window.close();
          // Fallback if window.close() doesn't work (browser restriction)
          setTimeout(() => {
            window.location.href = '/';
          }, 500);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [extensionUrl]);

  const handleCloseNow = () => {
    window.close();
    // Fallback if window.close() doesn't work
    setTimeout(() => {
      window.location.href = '/';
    }, 500);
  };

  if (!extensionUrl) {
    return null;
  }

  return (
    <div className="auth-container">
      <div className="auth-box" style={{ textAlign: 'center', maxWidth: '500px' }}>
        <h2 style={{ color: '#2c3e50', marginBottom: '20px' }}>Login Successful!</h2>

        <div style={{
          background: '#e8f5e9',
          border: '2px solid #4caf50',
          borderRadius: '8px',
          padding: '20px',
          marginBottom: '20px'
        }}>
          <svg
            style={{ width: '60px', height: '60px', marginBottom: '15px' }}
            fill="#4caf50"
            viewBox="0 0 24 24"
          >
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
          </svg>
          <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px', color: '#2c3e50' }}>
            You've successfully logged in!
          </p>
          <p style={{ fontSize: '14px', color: '#555' }}>
            You can now return to the Ref-Lex browser extension.
          </p>
        </div>

        <div style={{
          background: '#f5f5f5',
          borderRadius: '6px',
          padding: '15px',
          marginBottom: '20px',
          fontSize: '14px',
          color: '#666'
        }}>
          <p style={{ marginBottom: '5px' }}>
            This window will close automatically in <strong>{countdown}</strong> seconds.
          </p>
          <p style={{ marginBottom: '0', fontSize: '12px' }}>
            If it doesn't close, you can safely close this tab manually.
          </p>
        </div>

        <button
          onClick={handleCloseNow}
          style={{
            background: '#3498db',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            padding: '12px 30px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background 0.3s ease'
          }}
          onMouseOver={(e) => e.target.style.background = '#2980b9'}
          onMouseOut={(e) => e.target.style.background = '#3498db'}
        >
          Close Now
        </button>

        <p style={{
          marginTop: '20px',
          fontSize: '12px',
          color: '#999',
          borderTop: '1px solid #ddd',
          paddingTop: '15px'
        }}>
          Return to the extension to start capturing references
        </p>
      </div>
    </div>
  );
};

export default LoginSuccess;
